<div class="container-fluid container_global">
  <div class="row justify-content-center align-items-center mb-5">
    <div class="col-auto customTitlePage">
      <span>Calendario</span>
    </div>
    @if (googleConnected) {
      <div class="dropdown col-auto ms-2">
        <button class="btn btnCircle d-inline-flex align-items-center justify-content-center" type="button"
          data-bs-toggle="dropdown" [attr.aria-label]="'CALENDAR.GOOGLE.ADD' | translate">
          <i class="bi bi-plus-lg"></i>
        </button>
        <ul class="dropdown-menu">
          <li>
            <button type="button" class="dropdown-item" (click)="addEvento()">
              {{ 'CALENDAR.GOOGLE.WALLEY_EVENT' | translate }}
            </button>
          </li>
          <li>
            <button type="button" class="dropdown-item" (click)="addGoogleEvent()">
              {{ 'CALENDAR.GOOGLE.GOOGLE_EVENT' | translate }}
            </button>
          </li>
        </ul>
      </div>
    } @else {
      <button class="btn btnCircle col-auto d-inline-flex align-items-center justify-content-center ms-2" type="button"
        (click)="addEvento()" [attr.aria-label]="'CALENDAR.GOOGLE.ADD' | translate">
        <i class="bi bi-plus-lg"></i>
      </button>
    }
  </div>
  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="fetchEvents()"
          >
          Precedente
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="fetchEvents()"
          >
          Oggi
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="fetchEvents()"
          >
          Successivo
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h5>
        {{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}
      </h5>
    </div>
    <div class="col-md-4">
      <div class="btn-group" >
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"

          >
          Mese
        </div>
        <div
          class="btn btn-primary d-none d-md-block"
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
          >
          Settimana
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
          >
          Giorno
        </div>
      </div>
    </div>
  </div>
</div>
<br/>

@if (googleNeedsReauth) {
  <div class="alert alert-warning" role="status">
    {{ 'CALENDAR.GOOGLE.REASON.reauth' | translate }}
    <a class="ms-2" routerLink="/settings/userProfile">{{ 'CALENDAR.GOOGLE.GO_PROFILE' | translate }}</a>
  </div>
}
@if (googleWarning) {
  <div class="alert alert-warning" role="status">{{ googleWarning }}</div>
}
@if (googleCalendars.length) {
  <div class="d-flex flex-wrap gap-3 mb-3 px-2">
    @for (calendar of googleCalendars; track calendar.id) {
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [id]="'gcal-' + calendar.id"
          [checked]="calendar.visible === 1"
          (change)="toggleGoogleCalendar(calendar, $any($event.target).checked)">
        <label class="form-check-label" [for]="'gcal-' + calendar.id">
          <span class="google-cal-dot me-1" [style.background-color]="calendar.color"></span>
          {{ calendar.name }}
        </label>
      </div>
    }
  </div>
}

@if (events$ | async; as events) {
  <div>
    <div>
      @switch (view) {
        <!--<mwl-calendar-month-view
        *ngSwitchCase="'month'"
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="openEvent($event.day.date)"
        (eventClicked)="eventClicked($event.event)"
        >
      </mwl-calendar-month-view>-->
      @case ('month') {
        <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          [locale]="locale"
          [weekStartsOn]="weekStartsOn"
          [weekendDays]="weekendDays"
          [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent($event.event)"
          >
        </mwl-calendar-month-view>
      }
      @case ('week') {
        <mwl-calendar-week-view
          [viewDate]="viewDate"
          [events]="events"
          [locale]="locale"
          [weekStartsOn]="weekStartsOn"
          [weekendDays]="weekendDays"
          [dayStartHour]="dayStartHour"
          [dayEndHour]="dayEndHour"
          (eventClicked)="handleEvent($event.event)"
          >
        </mwl-calendar-week-view>
      }
      @case ('day') {
        <mwl-calendar-day-view
          [viewDate]="viewDate"
          [events]="events"
          [locale]="locale"
          [dayStartHour]="dayStartHour"
          [dayEndHour]="dayEndHour"
          (eventClicked)="handleEvent($event.event)"
          >
        </mwl-calendar-day-view>
      }
    }
  </div>
</div>
}
<!-- <div class="button_sticky">
<button mat-fab color="primary" title="Aggiungi" aria-label="Aggiungi evento" (click)="addEvento()">
  <mat-icon>add</mat-icon>
</button>
</div> -->
